import ArrowBottom from "../../../../assets/icons/Arrow/ArrowBottom";
import ArrowRight from "../../../../assets/icons/Arrow/ArrowRight";
import { CategoryType } from "../../../../store/slice/productsSlice";
import { RootState } from "../../../../store/store";
import "./LeftPanel.scss";
import cx from "classnames";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const Items = ({
  category,
  isActive,
}: {
  category: CategoryType;
  isActive: boolean;
}) => {
  const [viewSubmenu, setViewSubmenu] = useState(isActive ?? false);
  const params = useParams();
  const navigate = useNavigate();

  return (
    <div>
      <div
        className={cx("category-items", {
          active: params.category === category.code,
        })}
        onClick={() => setViewSubmenu(!viewSubmenu)}
      >
        {viewSubmenu ? <ArrowBottom /> : <ArrowRight />}
        <p>{category.name?.toUpperCase()}</p>
      </div>
      {viewSubmenu && (
        <div className="submenu-items">
          {category.subcategories.map((subcategory) => (
            <p
              key={`items-subcategory-line-${subcategory.code}`}
              onClick={() =>
                navigate(`/category-product/${category.code}/${subcategory.code}`)
              }
              className={params.subcategory === subcategory.code ? "active" : ""}
            >
              {subcategory.name}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

const LeftPanel = () => {
  const params = useParams();
  const { categories } = useSelector((state: RootState) => state.products);

  return (
    <div className="left-panel">
      {categories.map((categoryItem) => (
        <Items category={categoryItem} isActive={params.category === categoryItem.code} key={`item-category-${categoryItem.code}`} />
      ))}
    </div>
  );
};

export default LeftPanel;
